import { render, staticRenderFns } from "./AssociationModal.vue?vue&type=template&id=2b1bd33a&scoped=true"
import script from "./AssociationModal.vue?vue&type=script&lang=js"
export * from "./AssociationModal.vue?vue&type=script&lang=js"
import style0 from "./AssociationModal.vue?vue&type=style&index=0&id=2b1bd33a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b1bd33a",
  null
  
)

export default component.exports